import React from "react";
import { useStyles } from "./BasketImage.styles";
interface Props {}

export const BasketImage: React.FC<Props> = () => {
  const classes = useStyles();
  return <div className={classes.basketImage_root}>Basket Image</div>;
};
